import React, {FC, useContext, useEffect, useState} from 'react';
import CustomDialog from '../../../../common/components/CustomDialog';
import {Box, CircularProgress} from '@material-ui/core';
import {BusinessContext} from '../../BusinessProvider/BusinessProvider';
import BusinessDetailHeader from '../../Header/BusinessDetailHeader';
import {formatDate, getFullName} from '../../utils/utils';
import CustomSelect from '../../../../common/components/CustomSelect';
import ConfirmationButtons from '../../../ConfirmationButtons/ConfirmationButtons';
import {OptionType} from '../../../../common/components/CustomSelect/CustomSelect';
import {useGetManagers} from "../../../../hooks/queries/useGetManagers";
import {formatName} from "../../../../utils/common";

interface Props {
  onClose: () => void;
}

export const EditBusinessManagerModal: FC<Props> = (props) => {
  const { onClose } = props;
  const { businessState, setBusinessState } = useContext(BusinessContext);
  const { data, loading } = useGetManagers();
  const [selectedManager, setSelectedManager] = useState<number | null>(null);

  const managers: OptionType[] =
    data?.managers?.map((manager) => ({
      value: manager?.id ?? -1,
      label: formatName({
        firstName: manager?.firstName,
        lastName: manager?.lastName,
      }),
    })) || [];

  const _manager =
    data?.managers?.find((manager) => manager?.id === selectedManager) ||
    businessState?.manager;

  useEffect(() => {
    if (businessState?.manager?.id)
      setSelectedManager(businessState?.manager?.id);
  }, [businessState]);

  const handleChangeManager = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    const value = event.target.value;
    setSelectedManager(value as number);
  };

  return (
    <CustomDialog loading={false} maxWidth="sm" onClose={onClose} open={true}>
      <BusinessDetailHeader
        fullName={getFullName({
          firstName: businessState.firstName,
          lastName: businessState.lastName,
        })}
        apaName={getFullName({
          firstName: businessState.apa.firstName,
          lastName: businessState.apa.lastName,
        })}
        mandataryName={getFullName({
          firstName: businessState.mandatary?.firstName || '',
          lastName: businessState.mandatary?.lastName || '',
        })}
        createdAt={formatDate(businessState.createdAt)}
        apaEnseigneName={businessState.apa.enseigneName}
        status={businessState.step.label}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={100}
        pt={2}
        pb={2}>
        {loading ? (
          <CircularProgress size={22} />
        ) : (
          <CustomSelect
            label="Sélectionner un nouveau gestionnaire CC"
            value={selectedManager}
            options={managers}
            onChange={handleChangeManager}
          />
        )}
      </Box>

      <ConfirmationButtons
        handleCancel={onClose}
        handleConfirm={() => {
          if (_manager)
            setBusinessState((prevState) => ({
              ...prevState,
              manager: {
                id: _manager?.id,
                lastName: _manager?.lastName,
                firstName: _manager?.firstName,
              },
            }));
          onClose();
        }}
      />
    </CustomDialog>
  );
};
